'use client';

import { MappingUser, mappingUserTag } from '@ni/nimble-components/dist/esm/mapping/user';
import { wrap } from '../../utilities/react-wrapper';

export { mappingUserTag };
export { type MappingUser };
export const NimbleMappingUser = wrap(MappingUser);
